<app-confirm-dialog [(openDialog)]="openDialog" [header]="modalHeader"
  [yesText]="'vbeiYes'" [noText]="'vbeiCancel'" (confirmYes)="onDelete()" (confirmNo)="onCancel()">
    {{message}}
</app-confirm-dialog>